import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { useHistory } from "react-router-dom";

export default function Item({ data }) {
  const history = useHistory(); //habilitar history para redirecciones
  const onClick = (id) => {
    history.push(`event-detail/${id}`);
  };
  return (
    <Card
      sx={{ marginTop: 5, marginBottom: 5, cursor: "pointer", borderRadius: 8 }}
      variant="outlined"
      onClick={() => onClick(data._id)}
    >
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
      >
        <img
          src={data.image}
          alt="itemPic"
          style={{ width: "100%", height: "50%" }}
        />
      </Stack>
      <CardContent>
        <Typography
          variant="h5"
          style={{ textAlign: "center", fontStyle: "italic" }}
        >
          {data.name}
        </Typography>
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            Duration :
          </Typography>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            style={{ textAlign: "center" }}
          >
            {data.date}
          </Typography>
        </CardContent>
      </CardContent>
    </Card>
  );
}
